import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type IdentityState = {
  verifiedStatus?: boolean;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: Date;
  phoneNumber?: string;
  personalAddress?: Address;
};

export type Address = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
};

const initialState: IdentityState = {
  verifiedStatus: false,
};

const identitySlice = createSlice({
  name: "identity",
  initialState,
  reducers: {
    setVirifiedStatus: (state, action: PayloadAction<boolean>) => {
      state.verifiedStatus = action.payload;
    },
    setKycResult: (state, action: PayloadAction<IdentityState>) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.dateOfBirth = action.payload.dateOfBirth;
      state.phoneNumber = action.payload.phoneNumber;
      state.personalAddress = action.payload.personalAddress;
    },
  },
});

export const { setVirifiedStatus, setKycResult } = identitySlice.actions;

export default identitySlice.reducer;
